<script setup>

</script>
<template>
<i>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.9087 17.0909C18.9087 17.4767 18.7555 17.8467 18.4827 18.1194C18.2099 18.3922 17.84 18.5455 17.4542 18.5455H5.81783C5.43206 18.5455 5.06209 18.3922 4.78931 18.1194C4.51653 17.8467 4.36328 17.4767 4.36328 17.0909V6.9091C4.36328 6.52334 4.51653 6.15337 4.78931 5.88059C5.06209 5.60781 5.43206 5.45456 5.81783 5.45456H9.45419L10.9087 7.63638H17.4542C17.84 7.63638 18.2099 7.78962 18.4827 8.0624C18.7555 8.33518 18.9087 8.70515 18.9087 9.09092V17.0909Z" stroke="#174FDC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.82296 12.0355L4.47331 17.1264C4.16748 17.789 4.65148 18.5455 5.38127 18.5455H17.9058C18.2959 18.5455 18.6503 18.3187 18.8138 17.9645L21.1634 12.8736C21.4692 12.211 20.9852 11.4546 20.2554 11.4546H7.73092C7.34087 11.4546 6.98641 11.6814 6.82296 12.0355Z" fill="white" stroke="#174FDC" stroke-width="1.4"/>
  </svg>
</i>
</template>
<style scoped>

</style>